import { render, staticRenderFns } from "./GroupFaq.vue?vue&type=template&id=41357db2"
import script from "./GroupFaq.vue?vue&type=script&lang=js"
export * from "./GroupFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports